import React from 'react';
import { useWallet } from '../../context/WalletContext';
import { CURRENT_NETWORK } from '../../config/networks';
import { Spinner } from './Loader';

// Blocks child content until wallet is on the correct network.
// Automatically prompts a switch on first render (via connect flow) or on user click.
export default function NetworkGuard({ children }) {
  const { isConnected, isCorrectNetwork, switchNetwork, switching } = useWallet();

  if (!isConnected) return children; // Let downstream handle "connect wallet"
  if (isCorrectNetwork) return children;

  return (
    <div className="container" style={{ padding: '60px 24px' }}>
      <div className="card" style={{ maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
        <h3 style={{ marginBottom: 12 }}>Wrong Network</h3>
        <p style={{ marginBottom: 24 }}>
          You are connected to the wrong network. Please switch to{' '}
          <strong style={{ color: 'var(--accent)' }}>
            {CURRENT_NETWORK.displayName}
          </strong>{' '}
          to continue.
        </p>
        <button
          className="btn btn-primary btn-lg"
          onClick={switchNetwork}
          disabled={switching}
        >
          {switching ? <><Spinner /> Switching...</> : 'Switch Network'}
        </button>
      </div>
    </div>
  );
}
